import { REPORT_JOB_TYPES } from '@vy/types';
import saveAs from 'file-saver';
import { useMemo } from 'react';
import { runMutation } from '../../../../../utils/vy-mutation';
import { useReportTypeStateParam } from '../../reports-page-hooks/report-type-state-param-hook';
import { REPORT_TYPES } from '../../reports-page-types/report-type';
import type { ReportJobsDownloadProps } from '../report-jobs-section/ReportJobsSection';
import { getReportJobType } from '../ReportsPageContent';
import { useGetUsageReport } from '../../../../../hooks/requests/use-get-usage-report';

export const useUsageReportDownloadProps = () => {
  const getUsageReportDownloadMutation = useGetUsageReport();
  const [reportType] = useReportTypeStateParam();

  const selectedReportJob = getReportJobType(reportType ?? REPORT_TYPES.ALL_REPORTS);

  const downloadProps = useMemo(() => {
    if (selectedReportJob !== REPORT_JOB_TYPES.Usage) {
      return {};
    }

    return {
      asDownload: true,
      onDownload: async (reportJobId: string) => {
        await runMutation(
          getUsageReportDownloadMutation,
          { reportId: reportJobId },
          {
            pending: 'Downloading...',
            success: 'Download complete',
            error: 'Failed to download',
          },
          {
            onSuccess: async (usageReport) => {
              saveAs(usageReport, 'Usage Report');
            },
          },
        );
      },
    } satisfies ReportJobsDownloadProps;
  }, [selectedReportJob, getUsageReportDownloadMutation]);

  return downloadProps;
};
